module.exports = __webpack_public_path__ + "img/mastercard-icon.4503fec7.png";